import '../pages.css';
import { Link } from 'react-router-dom';

const ValplastCastComboPartial = () => {
    return (
        <div className="page product-detail">
            <section className="product-detail-hero">
                <div className="product-detail-hero-content">
                    <Link to="/products/removable" className="back-link">← Back to Removable Prosthetics</Link>
                    <h1>Valplast® Cast Combo Partial</h1>
                    <p className="product-tagline">Flexibility meets strength in a hybrid design</p>
                </div>
            </section>

            <section className="product-detail-content">
                <div className="content-container">
                    <div className="product-section">
                        <h2>Description</h2>
                        <p>
                            Valplast® cast combo partial dentures from <strong>AbELab</strong> combine the flexibility of Valplast® resin with
                            the strength of a metal framework. Valplast® is a biocompatible nylon thermoplastic known for its excellent esthetic
                            qualities and adaptability. This hybrid design allows for superior retention, improved comfort, and enhanced durability
                            while maintaining a lightweight and thin profile for optimal patient acceptance.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ValplastCastComboPartial;
